import React from 'react';
import { map } from 'lodash';
import { MenuItem } from './MenuItem';
import { SubMenuItemProps } from './SubMenu';

export interface Setting {
  icon: string;
  text: string;
  url?: string;
  action?: () => void;
  subMenuAction?: (value: number) => void;
  subMenuItems?: SubMenuItemProps[];
  selectedSubMenuItem?: number;
  show: boolean;
}
interface DataType {
  activeIndex: number;
  itemsSettings: Setting[];
}
interface Props {
  options: DataType;
  className?: string;
}
export const Menu = ({ options, className }: Props) => {
  const { itemsSettings, activeIndex } = options;
  const menuItems = map(itemsSettings, (setting, index: number) => {
    if (setting.show) {
      return (
        <MenuItem setting={setting} isActive={activeIndex === index} key={`menuAdList${index}`} />
      );
    }
  });
  return (
    <div className={className}>
      <ul className="fw4 f13 pl0">{menuItems}</ul>
    </div>
  );
};
